<template>
  <div class="max-w-7xl mx-auto p-6" v-if="isLoading">
    <Spinner />
  </div>

  <div v-else>
    <main
      class="bg-gradient-to-r from-green-100 to-blue-100 dark:from-gray-800 dark:to-gray-900 text-black dark:text-white transition-colors duration-500 ease-in-out"
    >
      <!-- Sección de Quiénes Somos -->
      <section
        class="flex flex-col md:flex-row items-center p-8 md:p-12 rounded-2xl shadow-lg bg-gradient-to-r from-green-100 to-blue-100 dark:from-gray-800 dark:to-gray-900 text-black dark:text-white transition-all duration-500 ease-in-out hover:shadow-2xl"
      >
        <div class="md:w-1/2 p-6 transition-all duration-500 ease-in-out">
          <h1
            class="text-4xl font-extrabold mb-6 tracking-tight text-gray-900 dark:text-white"
          >
            ¿Quiénes Somos?
          </h1>
          <p
            class="mb-4 text-lg text-gray-700 dark:text-gray-300 leading-relaxed transition-colors duration-500"
          >
            PRODESSA es una microfinanciera ubicada en Matagalpa, con sucursales
            en Matagalpa y León. Atendemos a pequeños y medianos empresarios en
            los sectores de Comercio, Servicio e Industria, tanto en zonas urbanas
            como rurales.
          </p>
          <p
            class="text-lg text-gray-700 dark:text-gray-300 leading-relaxed transition-colors duration-500"
          >
            Estamos inscritos y regulados por la Comisión Nacional de
            Microfinanzas (CONAMI). Con un gran potencial para impulsar la
            economía local, ofrecemos financiamientos que fomentan el desarrollo
            y crecimiento de los negocios, cumpliendo con las normativas de
            CONAMI.
          </p>
        </div>

        <div
          class="md:w-1/2 p-6 flex justify-center transition-transform duration-500 hover:scale-105"
        >
          <img
            src="../assets/Images/credit.jpg"
            alt="Nuestra Empresa"
            class="w-full h-auto object-cover rounded-2xl shadow-xl dark:shadow-gray-900/60 transition-all duration-500"
          />
        </div>
      </section>

      <!-- Sección de Tarjetas -->
      <section
        class="container mx-auto p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
      >
        <div
          class="card p-6 rounded-2xl shadow-lg dark:shadow-gray-900/50 bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm border border-gray-200 dark:border-gray-700 transition-all duration-500 hover:scale-105 hover:shadow-2xl"
        >
          <h2
            class="text-2xl font-bold mb-3 text-gray-900 dark:text-white transition-colors"
          >
            Misión
          </h2>
          <p
            class="text-md text-gray-700 dark:text-gray-300 leading-relaxed transition-colors"
          >
            Nuestra misión es brindar servicios eficientes a nuestros clientes
            con inclusión social, mediante productos financieros que se ajusten a
            sus necesidades, usando tecnología competitiva para fomentar el
            crecimiento en cartera y clientes en Matagalpa y León.
          </p>
        </div>

        <div
          class="card p-6 rounded-2xl shadow-lg dark:shadow-gray-900/50 bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm border border-gray-200 dark:border-gray-700 transition-all duration-500 hover:scale-105 hover:shadow-2xl"
        >
          <h2
            class="text-2xl font-bold mb-3 text-gray-900 dark:text-white transition-colors"
          >
            Visión
          </h2>
          <p
            class="text-md text-gray-700 dark:text-gray-300 leading-relaxed transition-colors"
          >
            Nuestra visión es ser una institución de referencia en el sector de
            microfinanzas, moderna y sólida, con prestigio y presencia en el
            país.
          </p>
        </div>

        <div
          class="card p-6 rounded-2xl shadow-lg dark:shadow-gray-900/50 bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm border border-gray-200 dark:border-gray-700 transition-all duration-500 hover:scale-105 hover:shadow-2xl overflow-y-auto h-96"
        >
          <h2
            class="text-2xl font-bold mb-3 text-gray-900 dark:text-white transition-colors"
          >
            Valores
          </h2>
          <ul
            class="list-disc list-inside space-y-1 text-md text-gray-700 dark:text-gray-300 transition-colors"
          >
            <li>Responsabilidad social, empresarial y ambiental.</li>
            <li>
              Cumplimiento de normativas sobre PLA/FT/FP y atención al usuario.
            </li>
            <li>
              Obediencia a la institucionalidad, comprometiéndonos a acatar los
              mandatos y directrices institucionales.
            </li>
            <li>Honradez y transparencia en todos nuestros procesos.</li>
            <li>
              Comportamiento ético dentro y fuera de nuestra empresa.
            </li>
            <li>
              Solidaridad con compañeros, clientes y la sociedad.
            </li>
            <li>
              Respeto como eje central en nuestras relaciones interpersonales.
            </li>
            <li>
              Tolerancia en la atención a clientes y en las relaciones laborales.
            </li>
          </ul>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Spinner from "../components/Spinner.vue";

const isLoading = ref(true);
const API_URL = import.meta.env.VUE_APP_API_URL;
const API_URL_FALLBACK = import.meta.env.VUE_APP_API_URL_FALLBACK;

onMounted(async () => {
  try {
    await fetch(`${API_URL}/about`);
    isLoading.value = false;
  } catch {
    try {
      await fetch(`${API_URL_FALLBACK}/about`);
      isLoading.value = false;
    } catch (error) {
      console.error("Error fetching data from both servers:", error);
    }
  }
});
</script>

<style scoped>
.card {
  transition: all 0.4s ease-in-out;
}
</style>
